
<div class="row">
  <div [ngClass]="{'d-none': loading}" *ngIf="!noStats" class="col-12">
    <div id="{{chartId}}"></div>
  </div>

  <div class="col-12" *ngIf="loading">
    <br /><br />
    <div class="align-items-center d-flex justify-content-center" *ngIf="loading">
      <app-calibrant-load [small]="true"></app-calibrant-load>
    </div>
    <br /><br />
  </div>

  <div class="col-12" *ngIf="noStats" style="text-align:center">
    <br/><br/><br/>
    <fa-icon ngbTooltip="Error getting stats." [icon]="faExclamationTriangle" size="3x"></fa-icon>
  </div>

</div>
